import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { ProductsProvider } from './context/ProductsContext';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductsSection from './components/ProductsSection';
import ProcessSection from './components/ProcessSection';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import CheckoutSuccess from './components/CheckoutSuccess';
import CheckoutCancel from './components/CheckoutCancel';
import AdminPanel from './components/AdminPanel';
import AccountPage from './components/AccountPage';
import WhatsAppButton from './components/WhatsAppButton';
import CartModalPortal from './components/CartModalPortal';
import TrackOrder from './pages/TrackOrder';
import ResetPassword from './pages/ResetPassword';
import TermsAndConditions from './pages/TermsAndConditions';

function HomePage() {
  return (
    <>
      <Header />
      <Hero />
      <ProductsSection />
      <ProcessSection />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <ProductsProvider>
        <CartProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/checkout/cancel" element={<CheckoutCancel />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/track-order" element={<TrackOrder />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/terms" element={<TermsAndConditions />} />
              </Routes>
              <WhatsAppButton />
              <CartModalPortal />
            </div>
          </Router>
        </CartProvider>
      </ProductsProvider>
    </AuthProvider>
  );
}

export default App;
